import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getBacklog } from 'services/glass-management/glassManagement';

export const fetchBacklog = createAsyncThunk('glass/backlog/fetch', async (filters) => {
    const res = await getBacklog(filters.start, filters.end);
    return { data: res };
});

export const backlogSlice = createSlice({
    name: 'glassBacklog',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchBacklog.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBacklog.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(fetchBacklog.rejected, (state, action) => {
                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load backlog';
                state.data = null;
            });
    }
});

export default backlogSlice.reducer;
